import ObjStoryParser from "../../../../../../shared/lib/html5-software-library/src/ranj/eng/story/framework/serialization/ObjStoryParser";
import LanguagePack from "../../../../../../shared/lib/html5-software-library/src/ranj/language/LanguagePack";
import AssetLibrary from "../../../../../../shared/src/ranj/app/assetloading/AssetLibrary";

/**
* StoryFactory.js
* 
* Created on 2-okt-2013, 16:51:34
*
* @author Ivo Swartjes for Ranj
**/
export default class NGTStoryFactory {

    /**
     * 
     * @param {AssetLibrary} assetLibrary 
     * @param {LanguagePack} languagePack 
     */
    constructor(assetLibrary, languagePack) {
        this.assetLibrary = assetLibrary;
        this.languagePack = languagePack;

        this.storyCache = {};
        this.storyParser = new ObjStoryParser(this.languagePack);
    }

    getStory(storyID) {
        var story = this.storyCache[storyID];
        if (story)
            return story;

        var jsonStr = this.assetLibrary.getAsset(storyID);
        if (!jsonStr)
            return null;

        var jsonObj;
        if (typeof jsonStr === 'string') {
            jsonObj = JSON.parse(jsonStr);
        } else {
            // Already parsed by PreloadJS
            jsonObj = jsonStr;
        }

        // Support loading .sty file directly
        if (!!jsonObj.story) {
            // NB: if no language pack is available in the Asset Library, then use Story file's language pack
            if (!this.assetLibrary.hasAsset(`${storyID}.lp`)) {
            var nwLanguagePack = new LanguagePack();
                nwLanguagePack.setPropertiesFromObject(jsonObj.languagePack);
                this.languagePack.merge(nwLanguagePack);
            }
            jsonObj = jsonObj.story;
        }

        story = this.storyParser.parseStory(jsonObj);
        if (!story)
            return null;

        this.storyCache[storyID] = story;

        return story;
    }
}


